export const AVAILABLE_LANGUAGES = ['en'];
